export default __webpack_public_path__ + "static/media/Illustration_Gears.8dbf069a.svg";